module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/axios@0.19.2/~/axios/index.js
// module id = 349
// module chunks = 0